import { RegistrationDetailsOverviewService } from '@app/registrations/shared/services/registration-details-overview/registration-details-overview.service';

export const coreServiceProviders = [RegistrationDetailsOverviewService];
